import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { GestioneCrawlingService } from '../../../services/gestione-crawling.service';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-crawling-operations',
  imports: [MatCardModule, MatTabsModule, MatSelectModule, FormsModule, CommonModule, ReactiveFormsModule, MatIconModule, MatIcon, MatInputModule, MatFormFieldModule, MatProgressSpinnerModule],
  templateUrl: './crawling-operations.component.html',
  styleUrl: './crawling-operations.component.scss'
})
export class CrawlingOperationsComponent implements OnInit {
  
  formData!: FormGroup;
  // http o https obbligatorio
  urlPattern = /^https?:\/\/.+$/;

  isLoading = false;

  constructor(private readonly fb: FormBuilder, private readonly crawlingService: GestioneCrawlingService, private readonly notificationService: NotificationService){}

  ngOnInit(): void {
    this.formData = this.fb.group({
      documentUrl: ['', [Validators.required, Validators.pattern(this.urlPattern)]]
    });
    
  }

  indicizzaDocumenti(formDirective: FormGroupDirective){
    if(this.formData.invalid) return;
    this.isLoading = true;
    this.formData.disable();
    const urlToProcess = this.formData.getRawValue().documentUrl;

    this.crawlingService.indexingSingleUrl(urlToProcess).subscribe({
      next: () => {
        this.isLoading = false;
        this.formData.enable();
        formDirective.resetForm();
        this.formData.reset();
        this.notificationService.indexingSuccess();
      },
      error: () => {
        this.isLoading = false;
        this.formData.enable();
        this.notificationService.indexingError();
      }
    });
  }
}
